import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { AccountService } from './accountservice';
import { firstValueFrom, Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { response } from '../model/Response';
import { environment } from 'src/environments/environment.prod';
@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  key = '1^*%^&#@$*&1';
  BUID: string;
  myAppApi: string;
  constructor(private _http: HttpClient) {
    this.myAppApi = environment.appUrl;
  }
    httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      Accept: '*/*',
    }),
  };

  getAppSettingAsync(source: string): Observable<any> {
  
      return this._http.get<response>(this.myAppApi + "api/Master/BusinessSettingList?Id=0", this.httpOptions);
        
    }

  public saveData(key: string, value: string) {
    // value = CryptoJS.AES.encrypt(value, this.key).toString()
    // localStorage.setItem(key, value);

    localStorage.setItem(key, value);
  }

  public getData(key: string) {
    let value = localStorage.getItem(key);

    if ( key=='AS' && (value == null || value == '' || value == undefined || value == 'undefined' || value == 'null')) {
      firstValueFrom(this.getAppSettingAsync('0'))
        .then((res) => {
          console.log(res);
          this.saveData('AS', JSON.stringify(res));
           value = localStorage.getItem(key);
          return value;
        })
        .catch((err) => {
          console.error(err);
        });
    }
    // let text = CryptoJS.AES.decrypt(value, this.key).toString(CryptoJS.enc.Utf8);
    // return text;
    return value;
  }
  public removeData(key: string) {
    localStorage.removeItem(key);
  }

  public clearData() {
    //localStorage.clear();
     // localStorage.clear();
        let STORAGE_KEY = 'SH';
        for (let i = localStorage.length - 1; i >= 0; i--) {
          const key = localStorage.key(i);
          if (key && key !== STORAGE_KEY) {
            localStorage.removeItem(key);
          }
        }
  }
}
